import Image from '@tiptap/extension-image'

const S3Image = Image.extend({
  name: 's3image',
  addOptions() {
    return {
      ...this.parent?.(),
      allowBase64: true,
    }
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      src: { default: null },
      'data-key': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-key'),
        renderHTML: (attributes) => {
          if (!attributes['data-key']) return {}
          return { 'data-key': attributes['data-key'] }
        },
      },
    }
  },
})

export default S3Image
